import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropertyHeader from "../../Projects/AssociatePanel/componets/HeaderProperty/PropertyHeader";
import EcomHeader from "../../Projects/OrgEcommerce/Componets/HeaderEcom/EcomHeader";
import useApiRequest from "../../Hooks/apiReq";
import { useDispatch } from "react-redux";
import { assoProfileDetails } from "../../Redux/Slices/associateProfileDetailsSlice";
import NewYearWish from "../../CommonComponets/NewYearWish";
const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("loggedInUser");
  const dispatch = useDispatch();
  const apptype = sessionStorage.getItem("Apptype");
  const { error, loading, recallRequest, response, sendApiRequest } =
    useApiRequest();
  const getAssociateProfile = () => {
    sendApiRequest("POST", "/Profile/GetProfileDetails", "", {
      onSuccess: (res) => {
        // console.log("Profile Data", res);
        dispatch(assoProfileDetails.setProfileDetails(res?.data));
      },
    });
  };
  useEffect(() => {
    if (!token) {
      navigate("/login", { replace: true });
    } else getAssociateProfile();
  }, [token, navigate]);
  return (
    <>
      {apptype === "Business" ? <PropertyHeader /> : <EcomHeader />}
      {/* <Breadcrumb /> */}
      <NewYearWish />
      {children}
    </>
  );
};
export default PrivateRoute;
